// src/components/Assets/ConfirmationModal.js
// Reusable confirmation modal component

import React from "react";
import { useTranslation } from "react-i18next";
import { FaTimes, FaExclamationTriangle, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import PropTypes from "prop-types";
import "./style.css";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  isSubmitting,
  type = "danger" // "danger", "success", "warning"
}) => {
  const [t] = useTranslation();

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal-overlay") && !isSubmitting) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return <FaCheckCircle className="modal-icon modal-icon-success" />;
      case "danger":
        return <FaTimesCircle className="modal-icon modal-icon-danger" />;
      case "warning":
        return <FaExclamationTriangle className="modal-icon modal-icon-warning" />;
      default:
        return <FaExclamationTriangle className="modal-icon modal-icon-warning" />;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content confirmation-modal">
        {/* Modal Header */}
        <div className="modal-header">
          <h2>{title}</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            disabled={isSubmitting}
          >
            <FaTimes />
          </button>
        </div>

        {/* Modal Body */}
        <div className="confirmation-modal-body">
          {getIcon()}
          <p className="confirmation-message">{message}</p>
        </div>

        {/* Modal Actions */}
        <div className="modal-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            {cancelText || t("Cancel")}
          </button>
          <button
            type="button"
            className={`btn-primary ${type === "danger" ? "btn-danger" : ""}`}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("Processing...") : (confirmText || t("Confirm"))}
          </button>
        </div>
      </div>
    </div>
  );
};

// PropTypes validation
ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  isSubmitting: PropTypes.bool,
  type: PropTypes.oneOf(["danger", "success", "warning"])
};

ConfirmationModal.defaultProps = {
  isSubmitting: false,
  type: "danger"
};

export default ConfirmationModal;
